import {Outlet,useNavigate} from 'react-router-dom';// desde la V6 es routes no switch
import { Container, IconButton, Toolbar } from '@mui/material';
import logoespol from '../../recursos_iconos/Portal_Investigacion_r.svg';
import { FaUserTie } from "react-icons/fa";
import '../Icono/cardIcon.css';
import Footer from '../Footer/Footer';


export default function PortalInvestigacionLayout () {
    let history = useNavigate();
    const goToNavigation = (site:string) =>{
        history(site)
    }
    
      return (  
        <div>
            <div className='centrado' style={{ paddingTop:'25px', paddingBottom:'25px', borderBottom: '2px solid #243165', display: 'flex', justifyContent: 'space-between'}} >
                <img className='imgBox' width='350px' height='auto' src={logoespol} alt="" style={{marginLeft:'10%'}} onClick={() => {goToNavigation('/inicio/portalinvestigacion')}} />
                <IconButton color="default" style={{ color: '#243165', padding: '30px' }} onClick={() => goToNavigation('/')}>
                    <FaUserTie />
                </IconButton>
            </div>
            <Container maxWidth="lg" style={{paddingTop: '50px', paddingBottom:'50px'}}>
                <div className='wrapper'>
                    <Outlet/>
                </div>
            </Container> 
            <div>
                <Footer />
            </div> 
        </div>              
      );
  }
  